<template>
    <!-- 企业支付方案  -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'plan',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--39.png",
        }
    },
    computed: {
        title() {
            return this.$t('plan.title');
        },
        subtitle() {
            return this.$t('plan.subtitle');
        },
        description() {
            return this.$t('plan.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>